export default "__VITE_ASSET__BNKjw785__ 584w";